import PropTypes from 'prop-types';

export default PropTypes.shape({
  center: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }),
  zoom: PropTypes.number,
});
